import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added for navigation
import '../../assets/styles/AirFreight.css';

function AirFreight() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Air Freight</title>
        <meta name="description" content="Fast and secure air freight services for urgent shipments." />
      </Helmet>
      <section className="air-freight-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="air-freight-image img-fluid rounded"
                alt="Air Freight Services"
              />
            </div>
            <div className="col-md-6">
              <h2 className="service-title fw-bold mb-4">Air Freight Services</h2>
              <p className="service-description">
                Our air freight solutions provide rapid and reliable delivery for time-sensitive cargo. With a global network of partners, we ensure your shipments reach their destination swiftly and securely. Whether it's urgent documents or heavy cargo, RFF Cargo offers tailored air freight services to meet your needs.
              </p>
              <Link to="/contact" className="btn btn-contact-us mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AirFreight;